'use strict';

// add tracking for paps
require(['app'], function (app) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = document.querySelectorAll('.item .item_inner .item-promo-holder .pap-container')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var pap = _step.value;

      pap.addEventListener('click', function () {
        app.publish('tracking/record', 'Pap | papBanner', 'Clicked', 'productListProduct pap');
      });
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
});

/* eslint-disable */
// Require optional shared components
require(['componentLoader'], function (helper) {
  var config = THEHUT.config;

  // This site's module parameters
  helper.updateConfig({
    ajaxBasket: {
      excludeTick: true,
      recommendationsParentClass: 'recommendations-section',
      recommendationsHeaderClass: 'heading',
      recommendationsClass: 'item',
      recommendationsHeaderEncloseElement: 'h3',
      maxRecommendations: 4,
      basketQuantityClass: 'basket-item-qty',
      thumbnailImageSize: 'large',
      fb_minHeight: 50
    },
    imageZoom: {
      bx_mode: 'horizontal',
      bx_controls: false,
      bx_pause: 4000,
      bx_infiniteLoop: false,
      bx_displaySlideQty: 4,
      bx_moveSlideQty: 4,
      bx_startingSlide: 0,
      bx_slideWidth: 150,
      bx_hideControlOnEnd: false,
      productArea: '.product-image-col .media',
      thumbnailSelector: '.product-image-col .product-thumbnails'
    },
    dispatchCountdown: {
      sundayDelivery: true
    },
    quickView: {
      minWidth: 1010,
      minHeight: 400
    },
    sliderSet: {
      rs_transitionType: 'move',
      rs_arrowsNavAutoHide: false,
      rs_arrowsNav: true,
      rs_sliderDrag: true,
      rs_controlNavigation: 'none'
    }
  });

  // Add new shims
  helper.updateShim({
    facetTpl: {
      deps: ['handlebars'],
      exports: 'facetUpdateTpl'
    }
  });

  // Make these modules dependencies
  helper.promote(['brandsSelection', 'buyingRightNow', 'carouselSet', 'countdown', 'CurrencySelection', 'editorialVideoScript', 'fancyBoxVideo', 'countrySwitcher', 'sliderSet']);

  // Load anchorScroll
  if (siteObj.sectionName === 'brands') {

    helper.promote(['anchorScroll']);
  }

  helper.requireDependencies();
});

/* Youtube videos /videos/youtube-main.js - load the API and render via youtubePlayer */
require(['youtube', 'jquery'], function (youtube, $) {

  youtube('.js-youtube-video').done(function () {
    // ytVideosArray: array of Youtube videos and player Api controls for further customisation

    var activeYTThumbClass = 'widget-youtube__gallery__menu__items__item--active';
    $('.youtube-video__gallery__menu__item').on('click', function () {
      $('.youtube-video__gallery__menu__item').removeClass(activeYTThumbClass);
      $(this).addClass(activeYTThumbClass);
    });
  });
});

define(['jquery', 'siteObj', 'common', 'expander', 'fancyBox', 'popup'], function ($, siteObj) {

  var lfint = {

    _initBannerLinks: function _initBannerLinks($bannerLinks) {
      //for putting links inside widget banners
      $bannerLinks.find('.btn[data-href], .data-link[data-href], .product-sku-link[data-href], .btn-link[data-href], .buttonPrimary[data-href]').click(function () {
        window.location = $(this).attr('data-href');
        return false;
      });
    },

    _initCountdownTimer: function _initCountdownTimer() {
      //Countdown Timer
      if (siteObj.customerLocation === 'GB') {
        if ($('.countdown-timer-product, .countdown-timer-widget').length) {
          require(['dispatchCountdown'], function (c) {
            c.initDispatchCountdown();
          });
        }
      }
    },

    _initCurrencySelector: function _initCurrencySelector() {
      //Currency Selector Behaviours
      require(['CurrencySelection'], function (CurrencySelection) {
        window.cSelect = new CurrencySelection('li.currency');
      });
    },

    _initSupportsTouch: function _initSupportsTouch(supportsTouch) {
      // touch devices
      if (supportsTouch) {
        $('body').addClass('supports-touch');
      }
    },

    _initProductImageFancyBox: function _initProductImageFancyBox() {
      //load product image in fancybox
      $('.fb-zoom').fancybox({
        'margin': 50,
        'padding': 5,
        'arrows': false
      });
    },

    _initVariationsOnListPages: function _initVariationsOnListPages($body, initial_fb_content) {
      // Handle list page variations products.
      if ($body.hasClass('list') || $body.hasClass('dept') || $body.hasClass('searchlist') || $body.hasClass('product')) {
        $body.on('click', '.quickview, .quickview-buy', function () {

          var contents,
              page_url = $(this).attr('href'),

          //basket_utils = utils.basket,
          fb_opts = {
            afterShow: function afterShow() {
              // Bind close events
              $('.product-quick-view').delegate('.close-fb', 'click', function (e) {
                $.fancybox.close();
                e.preventDefault();
              });
            },
            beforeClose: function beforeClose() {
              $('.product-quick-view').undelegate('.close-fb');
            }
          };

          siteObj.productID = $(this).closest('.item').attr('rel');

          if ($().fancybox) {
            $.fancybox(initial_fb_content, $.extend({
              'closeBtn': false
            }, fb_opts));
          }

          $.ajax({
            url: page_url,
            cache: false,
            data: 'ajax=true',
            dataType: 'html',
            success: function success(result) {
              contents = quickView(result, page_url);
              $.fancybox.close();
              $.fancybox(contents, $.extend({
                'closeBtn': false
              }, fb_opts));
              $('.fancybox-inner').fadeIn('400', function () {

                if ($('input[name=\'cheapest-product-id\']').length) {
                  basket_utils.preselected_product = true;
                }
                $('.buying-area button[disabled=\'disabled\']').removeAttr('disabled').addClass('disabled');
              });
            }
          });
          return false;
        });
      }
    },

    _initFancyBoxDefaults: function _initFancyBoxDefaults() {
      $.fancybox.defaults = $.extend($.fancybox.defaults, {
        'height': 'autoSize',
        'width': 1010,
        'minWidth': 350,
        'maxWidth': 1010,
        'minHeight': 200,
        'margin': 0,
        'padding': 15,
        'overflow': 'visible'
      });
    },

    _initFancyBox: function _initFancyBox() {
      //todo what is this?
      if ($().fancybox) {
        var $question = $('.question'),
            $fbClose = $('.fb-close'),
            $selector = $('.fb'),
            $onLoadSelector = $('.fb-onload'),
            fancybox_opts = {
          'closeBtn': false,
          'init': function init($this, markup) {
            var content;
            if (markup === true) {
              content = $this.html();
            }
            $this.fancybox({
              'content': content,
              'onComplete': function onComplete() {
                fancybox_opts.events();
              },
              'afterShow': function afterShow() {
                fancybox_opts.events();
              },
              'onClosed': function onClosed() {
                fancybox_opts.cleanup();
              }
            });
          },
          'events': function events() {
            $fbClose.on('click', function (e) {
              e.preventDefault();
              $.fancybox.close(true);
            });
          },
          'cleanup': function cleanup() {
            $question.find('[data-answer]').unbind('click');
          }
        };

        fancybox_opts.init($selector);
        fancybox_opts.init($onLoadSelector, true);
        $onLoadSelector.click();
      }
    },

    _initProductPage: function _initProductPage() {
      if (siteObj.type === 'product') {
        var $productBrandLogo = $('.product-brand-logo'),
            $brandLogoImage = $productBrandLogo.find('.product-logo-img'),
            $img = document.createElement('img');

        if ($brandLogoImage.length) {
          $img.onload = function () {
            $productBrandLogo.addClass('visible');
          };
          $img.src = $brandLogoImage.attr('src');
        }

        var $variationDropDowns = $('.variation-dropdowns');
        if ($variationDropDowns.length > 0 && $('#opts-4').length > 0 && $('ul.colour-swatches-list').length < 1 || $variationDropDowns.length > 0 && $('#opts-2').length > 0) {
          require(['colourswatches'], function (colourswatches) {
            colourswatches.colourSwatchesForSelectBoxWithLabel('opts-4');
            colourPicker();
          });
        }

        // Enables page scrolling to an id on
        var $reviewStars = $('.has-reviews .link');
        var $customerReviews = $('#customer-reviews');
        $reviewStars.click(function () {
          $('html, body').animate({
            scrollTop: $customerReviews.offset().top - 20
          }, 750);
        });

        // product page PAP popup
        var $promoDesc = $('.product-promo .product-promo-desc'),
            $promo = $promoDesc.length ? $promoDesc.parent() : false;

        if ($promo) {
          $promo.find('h3').css('cursor', 'pointer').click(function () {
            var html = $promo.wrap('<div />').parent.html();
            $.fancybox(html, {
              'width': 400,
              'maxWidth': 400,
              'height': 'auto'
            });
          });
        }
      }
    },

    _initReadMore: function _initReadMore($body) {
      // Read more expand text for department & list pages
      if ($body.is('.dept, .list, .product') && $('div').hasClass('expand-text')) {

        $('.expand-text p, .expand-text span').css('visibility', 'visible'); // To stop the jerky motion when the page is loaded

        $('.expand-text').expander({
          slicePoint: 450,
          preserveWords: true,
          widow: 4,
          expandEffect: 'fadeIn',
          expandSpeed: 400,
          collapseEffect: 'fadeOut',
          collapseSpeed: 400,
          collapseTimer: 0,
          expandPrefix: ''
        });

        // opens product page description when clicking read more on quickview.

        if (siteObj.type === 'product' && window.location.hash === '#productOverview') {
          var $readMore = $('.product-info .read-more a');
          $readMore.click();
        }
      }
    },

    _initListSortDropdown: function _initListSortDropdown($listSort) {
      //handle list sort dropdown
      if (!$('.facets-panel').length) {
        $listSort.change(function () {
          var $this = $(this);
          $this.parents('form:first').submit();
        });
      }
    },

    _initHelpSitePopup: function _initHelpSitePopup($body) {
      // help site pop up
      $body.on('click', 'a[href^=\'http://help.lookfantastic\'], a[href^=\'http://aide.lookfantastic\'], a[href^=\'http://ayuda.lookfantastic\'], a[href^=\'http://hilfe.lookfantastic\']', function (e) {
        var helpurl = $(this).attr('href');

        // check if there are query string parameters in the link already
        if (helpurl.indexOf('?') === -1) {
          helpurl += '?';
        } else {
          helpurl += '&';
        }

        var isLocale = /en_US|en_AU|en_AE|en_HK|de_DE|nl_NL|nl_BE|fr_BE|en_CA|fr_CA|de_AT|ar_AE|he_IL|it_LT|pt_BR|zh_HK|zh_TW|en_SG|en_IN/ig.test(siteObj.customerLocale);

        if (isLocale) {
          // lang and locale value for overriding 2 digit locals
          helpurl += 'lang=' + siteObj.selectedLang + '-' + siteObj.countryCode;
        } else {
          // lang value only
          helpurl += 'lang=' + siteObj.selectedLang;
        }
        window.open(helpurl, '', 'height=800,scrollbars=yes,width=785', false);
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
      });
    },

    _initTooltipPopups: function _initTooltipPopups() {
      //initialize tooltip  popups
      if ($().popover) {
        $('.lbl-help').popover({
          trigger: 'manual'
        }).hover(function () {
          //trigger the popover manually to allow us to set a timer to keep it open
          $('.lbl-help').popover('hide'); // hide all open popups
          $(this).popover('show'); //show current one
        }).mouseleave(function () {
          setTimeout('$(\'.popover\').hide()', 2000); //hide popup after 2 seconds
        });
      }
    },

    _initSalonMap: function _initSalonMap($salonMap) {
      // Function for populating the google maps on salon pages

      if ($salonMap.length) {

        if (siteObj.maps.postcode.length && siteObj.maps.postcode !== '') {

          siteObj.fn.loadmap = function () {

            var geocoder = new google.maps.Geocoder();

            var contentString = '<div class="info-window">' + '<h2>Find Us</h2>' + '<div class="salon-address"> ' + siteObj.maps.address + '</div>' + '<div class="info-window-description"> ' + siteObj.maps.description + '</div>' + '</div>';

            geocoder.geocode({
              'address': siteObj.maps.postcode
            }, function (results, status) {
              if (status === google.maps.GeocoderStatus.OK) {

                var location = results[0].geometry.location,
                    lat = location.lat(),
                    lng = location.lng(),
                    latlng = new google.maps.LatLng(lat + 0.005, lng);

                var mapOptions = {
                  zoom: 15,
                  center: location,
                  mapTypeId: google.maps.MapTypeId.ROADMAP
                };

                var map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

                map.panTo(latlng);

                var marker = new google.maps.Marker({
                  position: location,
                  map: map,
                  title: siteObj.maps.postcode
                });

                var infowindow = new google.maps.InfoWindow({
                  content: contentString
                });

                infowindow.open(map, marker);

                google.maps.event.addListener(marker, 'click', function () {
                  infowindow.open(map, marker);
                });
              } else {
                alert('Geocode was not successful for the following reason: ' + status);
              }
            });
          };

          siteObj.fn.loadScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyBRWqpVDemRjVjXtI_FrUBpDoQXTvBnfhU&v=3.exp&sensor=false&callback=siteObj.fn.loadmap');
        }
      }
    },

    _initCarouselSet: function _initCarouselSet() {
      require(['carouselSet'], function (carouselSet) {
        carouselSet.init({
          sliderDrag: true,
          sliderTouch: true,
          transitionType: 'move',
          arrowsNav: true,
          arrowsNavAutoHide: false,
          controlNavigation: 'none',
          keyboardNavEnabled: true,
          allowCSS3: true,
          loop: true,
          autoPlay: {
            enabled: false,
            pauseOnHover: true,
            delay: 3000
          }
        });
      });
    },

    _initProductSkuWidget: function _initProductSkuWidget() {
      require(['productSkuWidget'], function (productSkuWidget) {
        productSkuWidget.init({
          sliderDrag: true,
          sliderTouch: true,
          transitionType: 'move',
          arrowsNav: true,
          arrowsNavAutoHide: false,
          controlNavigation: 'bullets',
          keyboardNavEnabled: true,
          allowCSS3: false,
          loop: true,
          autoPlay: {
            enabled: false,
            pauseOnHover: true,
            delay: 3000
          }
        });
      });
    },

    _initAccountCreationScript: function _initAccountCreationScript() {
      // account creation page script
      if (siteObj.page === 'account-creation') {
        require(['accountCreate']);
      }
    },

    _initLoginPageScript: function _initLoginPageScript() {
      // login page scripts
      if (siteObj.page === 'login') {
        require(['loginPage']);
      }
    },

    _initProductReviewScript: function _initProductReviewScript() {
      if (siteObj.type === 'product') {
        require(['reviewPaging']);
      }
    },

    _initLivePersonScript: function _initLivePersonScript() {
      // Liveperson
      if (siteObj.props.testApps.lp && siteObj.customerLocation !== 'CN') {
        require(['livePerson']);
      }
    },

    _initGandalfScript: function _initGandalfScript() {
      // Gandalf
      if (siteObj.features.projectGandalf.active) {

        if (siteObj.sectionName === 'contact-us' || siteObj.page === 'contact-us') {
          require(['mvtBSContactP1']);
        }

        if (siteObj.page === 'customer-service') {
          require(['mvtBSContactP2']);
        }
      }

      if (siteObj.sectionName === 'customer-service') {
        require(['faq']);
      }
    },

    _initSliderSetStatic: function _initSliderSetStatic() {

      var $sliderSet = $('.slider-set .royal-slider');

      $sliderSet.each(function () {

        var theSlider = $(this);

        var slideConfig = {
          arrowsNav: true,
          loop: true,
          keyboardNavEnabled: false,
          controlsInside: false,
          // imageScaleMode: 'fill',
          slidesSpacing: 3,
          arrowsNavAutoHide: false,
          thumbsFitInViewport: false,
          navigateByClick: true,
          startSlideId: 0,
          transitionType: 'move',
          globalCaption: false,
          controlNavigation: 'bullets',
          autoHeight: true,
          autoScaleSlider: false,
          imageScaleMode: 'none',
          imageAlignCenter: false,
          autoPlay: {
            pauseOnHover: true,
            delay: 10000
          }
        };

        slideConfig.autoPlay['enabled'] = !theSlider[0].parentNode.classList.contains('slider-set-static');

        $(this).royalSlider(slideConfig);
      });

      $sliderSet.find('.btn[data-href]').click(function () {
        var location = $(this).attr('data-href');
        window.location = location;
        return false;
      });
    },

    _init: function _init() {

      var $body = $('body'),

      // Initial HTML markup to be added into Fancybox. Contains the loading spinner and hidden close button.
      initial_fb_content = '<div class="basketAlert"><img src="' + siteObj.siteNonSecureURL + 'common/images/loading.gif" alt="Loading" class="fb-loader" /></div>',
          $listSort = $('.list-sort select'),
          $salonMap = $('#map-canvas'),
          $bannerLinks = $('.media-block'),
          supportsTouch = 'ontouchstart' in window;

      lfint._initBannerLinks($bannerLinks);

      lfint._initCountdownTimer();

      lfint._initCurrencySelector();

      lfint._initSupportsTouch(supportsTouch);

      lfint._initProductImageFancyBox();

      lfint._initVariationsOnListPages($body, initial_fb_content);

      lfint._initFancyBoxDefaults();

      lfint._initFancyBox();

      lfint._initProductPage();

      lfint._initReadMore($body);

      lfint._initListSortDropdown($listSort);

      lfint._initHelpSitePopup($body);

      lfint._initTooltipPopups();

      lfint._initSalonMap($salonMap);

      lfint._initCarouselSet();

      lfint._initProductSkuWidget();

      lfint._initAccountCreationScript();

      lfint._initLoginPageScript();

      lfint._initProductReviewScript();

      lfint._initLivePersonScript();

      lfint._initGandalfScript();

      lfint._initSliderSetStatic();

      /* Javascript Healthcheck - Please keep this at the bottom of the file. */
      var healthCheck = document.createElement('span');
      healthCheck.id = 'jshealthcheck';
      document.body.appendChild(healthCheck);
    }
  };

  lfint._init();
  return lfint;
});
//# sourceMappingURL=lfint.js.map
